import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { UtilsModule } from '@lbmx/phoenix-lib-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, ProgressSpinnerModule } from 'primeng-lts';
import { ReassignOptionsContainerComponent } from './reassign-options-container.component';
import { ReassignOptionsComponent } from './reassign-options.component';

@NgModule({
  declarations: [ReassignOptionsComponent, ReassignOptionsContainerComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    ButtonModule,
    UtilsModule,
  ],
  exports: [ReassignOptionsContainerComponent],
})
export class ReassignOptionsModule {}
